/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _circle3, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _circle4, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _circle5, _path178, _path179, _circle6, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _switch, _switch2, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _circle7, _circle8, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _circle9, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _circle0, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318;
const didWarnAboutDeprecation = {};
const LogoFacebook = /*#__PURE__*/React.forwardRef(function LogoFacebook({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoFacebook.propTypes = iconPropTypes;
}
const LogoFigma = /*#__PURE__*/React.forwardRef(function LogoFigma({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2 c-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9 C6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3 c0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1 c1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7 c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2 c-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2 s0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7 c-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2 c-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2 c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4 c0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2 c0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5 L20.6,19.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoFigma.propTypes = iconPropTypes;
}
const LogoFlickr = /*#__PURE__*/React.forwardRef(function LogoFlickr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "6"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoFlickr.propTypes = iconPropTypes;
}
const LogoGit = /*#__PURE__*/React.forwardRef(function LogoGit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5242,14.8021L17.2022,2.5241c-.7013-.6988-1.8032-.6988-2.5045,0h0l-2.5045,2.4955,3.2057,3.1943c.8014-.2995,1.6029,0,2.2039.4991.6011.5989.8014,1.3975.5009,2.1961l3.1055,3.0945c.8014-.2995,1.6029,0,2.2039.4991.8014.7986.8014,2.1961,0,2.9947h0c-.8014.7986-2.2039.7986-3.0054,0-.6011-.5989-.8014-1.4973-.5009-2.2959l-2.9052-2.8948v7.5865c1.102.4991,1.5027,1.7968,1.0018,2.8948-.1002.1996-.2004.3993-.4007.5989-.8014.7986-2.2039.7986-3.0054,0h0c-.8014-.7986-.8014-2.1961,0-2.9947h0c.2004-.1996.4007-.3993.7013-.4991v-7.6863c-.3005-.0998-.5009-.2995-.7013-.4991-.6011-.5989-.8014-1.4973-.5009-2.2959l-3.2057-3.1943L2.4759,14.7023c-.7013.6988-.7013,1.7968,0,2.5954h0l12.2218,12.1783c.7013.6988,1.8032.6988,2.5045,0l12.2218-12.1783c.7013-.6988.7013-1.7968,0-2.5954"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoGit.propTypes = iconPropTypes;
}
const LogoGithub = /*#__PURE__*/React.forwardRef(function LogoGithub({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoGithub.propTypes = iconPropTypes;
}
const LogoGitlab = /*#__PURE__*/React.forwardRef(function LogoGitlab({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5678,12.8926l-.0366-.0934-3.5388-9.2356c-.072-.181-.1995-.3346-.3642-.4386-.3375-.2095-.7699-.1863-1.083.0582-.1512.1228-.2608.2892-.3141.4765l-2.3894,7.3105h-9.6756l-2.3894-7.3105c-.0518-.1884-.1617-.3556-.3141-.4779-.3131-.2445-.7455-.2677-1.083-.0582-.1643.1045-.2917.2579-.3642.4386l-3.5456,9.2315-.0352.0934c-1.0465,2.7345-.1578,5.8315,2.1796,7.5948l.0122.0095.0325.023,5.3908,4.037,2.667,2.0185,1.6246,1.2265c.3905.2965.9308.2965,1.3213,0l1.6246-1.2265,2.667-2.0185,5.4233-4.0614.0135-.0108c2.3319-1.7635,3.219-4.8551,2.1769-7.5867Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoGitlab.propTypes = iconPropTypes;
}
const LogoGlassdoor = /*#__PURE__*/React.forwardRef(function LogoGlassdoor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoGlassdoor.propTypes = iconPropTypes;
}
const LogoInstagram = /*#__PURE__*/React.forwardRef(function LogoInstagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.406",
    cy: "9.594",
    r: "1.44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoInstagram.propTypes = iconPropTypes;
}
const LogoInvision = /*#__PURE__*/React.forwardRef(function LogoInvision({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4 C10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1 l1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5 l-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoInvision.propTypes = iconPropTypes;
}
const LogoJupyter = /*#__PURE__*/React.forwardRef(function LogoJupyter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0766,3.5878a1.69,1.69,0,1,1-1.76-1.5853,1.67,1.67,0,0,1,1.76,1.5853Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2191,23.1113c-4.4866,0-8.43-1.61-10.4688-3.9882a11.1618,11.1618,0,0,0,20.9377,0C24.6541,21.5011,20.7257,23.1113,16.2191,23.1113Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2191,7.6483c4.4867,0,8.43,1.61,10.4689,3.9881a11.1618,11.1618,0,0,0-20.9377,0C7.7892,9.2535,11.7126,7.6483,16.2191,7.6483Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0427,27.7388a2.1085,2.1085,0,1,1-.2031-.7976,2.1278,2.1278,0,0,1,.2031.7976Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26,7.1064A1.2263,1.2263,0,1,1,7.4517,5.83,1.2415,1.2415,0,0,1,6.26,7.1064Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoJupyter.propTypes = iconPropTypes;
}
const LogoKeybase = /*#__PURE__*/React.forwardRef(function LogoKeybase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1233,26.9328a1.1122,1.1122,0,1,1-1.1121-1.1122,1.112,1.112,0,0,1,1.1121,1.1122"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0257,26.9328a1.1122,1.1122,0,1,1-1.1122-1.1122,1.1121,1.1121,0,0,1,1.1122,1.1122"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.999 5.797H10.973V6.771H9.999z",
    transform: "rotate(-86.462 10.486 6.284)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoKeybase.propTypes = iconPropTypes;
}
const LogoKubernetes = /*#__PURE__*/React.forwardRef(function LogoKubernetes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2166,13.88l.0024.0019a.5239.5239,0,0,0,.8321-.4013l0-.003.0127-.0063L15.242,10.33c-.2173.0268-.43.0635-.6333.1094a6.2,6.2,0,0,0-2.9727,1.6176l2.5752,1.8257Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8347,16.2622l.003-.001a.5241.5241,0,0,0,.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775,6.1775,0,0,0-.8746,3.9l3.0142-.87Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8645,18.501a.5229.5229,0,0,0-.6059-.3989l-.0034,0-.0049-.0063-3.0908.5249a6.2052,6.2052,0,0,0,2.4863,3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184,0,0,0,13.8645,18.501Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4622,19.6431l-.0015-.0025a.53.53,0,0,0-.48-.2759.5269.5269,0,0,0-.4434.2769l-.0015.0029H15.533l-1.52,2.7481a6.2277,6.2277,0,0,0,3.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7371,18.09l-.0034,0a.51.51,0,0,0-.1206-.0088.5263.5263,0,0,0-.4546.7319l.001.0024-.004.0054,1.21,2.9234A6.185,6.185,0,0,0,21.86,18.61l-3.1176-.5269Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2893,13.2437,18.951,15.3364l.0014.0064-.0024.0019a.5249.5249,0,0,0,.2055.9014l.0035.0005.0024.0132,3.0293.872a6.2915,6.2915,0,0,0-.9014-3.8881Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9383,13.4673l0,.0029a.5161.5161,0,0,0,.1143.3037.5236.5236,0,0,0,.7192.0967l.0025-.0019.0088.0039,2.5586-1.814a6.2307,6.2307,0,0,0-3.584-1.7285l.1777,3.1357Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoKubernetes.propTypes = iconPropTypes;
}
const LogoLinkedin = /*#__PURE__*/React.forwardRef(function LogoLinkedin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4 H7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3 H21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoLinkedin.propTypes = iconPropTypes;
}
const LogoLivestream = /*#__PURE__*/React.forwardRef(function LogoLivestream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,23.71h-.76c-2.26,0-4.52,0-6.78,0a3.12,3.12,0,0,1-2.41-1A14.91,14.91,0,0,1,10,18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84,7.84,0,0,0,2,5.6c1.24,0,2.41,0,3.57,0a45.63,45.63,0,0,1,7,.61,8.09,8.09,0,0,1,6.34,5.09,48.51,48.51,0,0,1,2.17,7.36A26,26,0,0,0,22.49,23.71Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,26.38a2.93,2.93,0,0,1-2.74-2.64,42.08,42.08,0,0,1-.14-4.9,48,48,0,0,0-.61-7.58,3.75,3.75,0,0,0-.83-2h2.65c.54,0,.73.37.89.78A12.1,12.1,0,0,1,28,13.28c.29,2.72.31,5.45.33,8.18a10.94,10.94,0,0,0,0,1.15c.09.78.4,1.1,1.17,1.08.5,0,.5-.06.5-.06v2.69A8.62,8.62,0,0,1,28.1,26.38Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoLivestream.propTypes = iconPropTypes;
}
const LogoMastodon = /*#__PURE__*/React.forwardRef(function LogoMastodon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m29.0581,11.1929c0-6.0742-3.9797-7.8545-3.9797-7.8545-2.0066-.9214-5.4522-1.3091-9.0318-1.3384h-.0879c-3.5798.0293-7.023.417-9.0296,1.3384,0,0-3.98,1.7803-3.98,7.8545,0,1.3911-.0271,3.0537.0171,4.8174.1445,5.9404,1.0889,11.7945,6.5811,13.2481,2.5322.6704,4.7063.8105,6.4573.7144,3.1755-.1758,4.958-1.1333,4.958-1.1333l-.1047-2.3037s-2.269.7153-4.8176.6284c-2.5249-.0869-5.1902-.2725-5.5986-3.3726-.0378-.272-.0566-.563-.0566-.8691,0,0,2.4785.606,5.6196.75,1.9207.0879,3.7219-.1128,5.5515-.3311,3.5083-.4189,6.563-2.5806,6.9468-4.5557.605-3.1113.5552-7.5928.5552-7.5928Zm-4.6943,7.8257h-2.9138v-7.1382c0-1.5049-.6331-2.2686-1.8997-2.2686-1.4002,0-2.1018.9058-2.1018,2.6973v3.9077h-2.8967v-3.9077c0-1.7915-.7019-2.6973-2.1021-2.6973-1.2666,0-1.8997.7637-1.8997,2.2686v7.1382h-2.9138v-7.3545c0-1.5029.3828-2.6978,1.1516-3.5811.7927-.8838,1.8308-1.3369,3.1196-1.3369,1.491,0,2.6204.5732,3.367,1.7192l.7256,1.2168.7261-1.2168c.7463-1.146,1.8755-1.7192,3.3667-1.7192,1.2886,0,2.3267.4531,3.1196,1.3369.7686.8833,1.1514,2.0781,1.1514,3.5811v7.3545Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoMastodon.propTypes = iconPropTypes;
}
const LogoMedium = /*#__PURE__*/React.forwardRef(function LogoMedium({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16c0,3.7-0.6,6.7-1.4,6.7c-0.8,0-1.4-3-1.4-6.7s0.6-6.7,1.4-6.7C29.4,9.3,30,12.3,30,16"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,16c0,4.1-1.8,7.5-3.9,7.5s-3.9-3.4-3.9-7.5s1.8-7.5,3.9-7.5S26.5,11.9,26.5,16"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,16c0,4.4-3.5,8-7.9,8S2,20.4,2,16s3.5-8,7.9-8S17.8,11.6,17.8,16"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoMedium.propTypes = iconPropTypes;
}
const LogoNpm = /*#__PURE__*/React.forwardRef(function LogoNpm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoNpm.propTypes = iconPropTypes;
}
const LogoOpenshift = /*#__PURE__*/React.forwardRef(function LogoOpenshift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoOpenshift.propTypes = iconPropTypes;
}
const LogoPinterest = /*#__PURE__*/React.forwardRef(function LogoPinterest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoPinterest.propTypes = iconPropTypes;
}
const LogoPython = /*#__PURE__*/React.forwardRef(function LogoPython({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoPython.propTypes = iconPropTypes;
}
const LogoQuora = /*#__PURE__*/React.forwardRef(function LogoQuora({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoQuora.propTypes = iconPropTypes;
}
const LogoRScript = /*#__PURE__*/React.forwardRef(function LogoRScript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoRScript.propTypes = iconPropTypes;
}
const LogoReact = /*#__PURE__*/React.forwardRef(function LogoReact({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9 c-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1 c-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2 c1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9 c2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3 C17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4 C9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4 C10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1 c0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2 c-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9 c0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6 c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3 c0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4 c-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6 c-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3 C8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1 c-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7 c-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7 c-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7 C23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5 c0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3 c-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoReact.propTypes = iconPropTypes;
}
const LogoRedHatAiInstructlabOnIbmCloud = /*#__PURE__*/React.forwardRef(function LogoRedHatAiInstructlabOnIbmCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2148,13.1793c.2327-.501-.4158-.9337-.9252-.8189-.3831.0863-.8737.7158-1.0126,1.0705.0842.5294,1.6957.2715,1.9378-.2516ZM12.8453,12.7614c.06.5895-.6263.5432-1.0515.5242.2484-.3642.5768-.7484,1.0515-.5242ZM16,21.8211c.9062-.0084,1.2-1.8673.4673-2.0052-.0768-.0137-.2548-.0231-.4673-.0253-.2126.0021-.3906.0116-.4674.0253-.7326.1379-.4389,1.9968.4674,2.0052ZM12.154,19.6017c1.2337-.0746,1.1996-2.8773-.0815-2.8101-1.4228.0746-1.2452,2.8903.0815,2.8101ZM26.8406,9.7584c-.52-.6715-1.2484-2.2767-2.0789-2.4473-1.2431-.2547-2.1147.3842-2.923,1.221-1.6652-1.2252-3.7147-2.3188-5.8387-2.3052-2.1241-.0137-4.1736,1.08-5.8387,2.3052-.8084-.8368-1.68-1.4757-2.9231-1.221-.8305.1705-1.5589,1.7758-2.0789,2.4473-.9073,1.1747-3.1978,3.1746-3.1588,4.7346.0484,1.9073,4.4714,7.2376,6.3776,7.5229.4211.0631.7842-.0421,1.1874-.0842.7214,1.4147,1.8981,2.4644,3.2742,3.1268,1.9797.953,4.3409.953,6.3207,0,1.376-.6624,2.5527-1.7121,3.2742-3.1268.4031.0421.7662.1473,1.1873.0842,1.9062-.2853,6.3292-5.6156,6.3777-7.5229.0389-1.56-2.2515-3.5599-3.1589-4.7346h-.0001ZM11.1285,9.2016c1.6884-1.1799,3.2167-1.8304,4.8715-1.7957,1.6547-.0347,3.183.6158,4.8714,1.7957.3747.261,1.4536,1.0516,1.6978,1.3547.5905.7305.5526,3.2515.5853,4.204h-2.1263c-.9337,0-1.8673.001-2.801,0-.3168,0-.6905.201-.9157.421-.6642.6505-.2316,1.52-.2632,2.3157-.3494-.1453-.6979-.2-1.0483-.2084-.3505.0084-.699.0632-1.0484.2084-.0316-.7958.401-1.6652-.2632-2.3157-.2252-.22-.5989-.421-.9157-.421-.9337.001-1.8673,0-2.801,0h-2.1263c.0327-.9526-.0052-3.4736.5853-4.204.2442-.3032,1.3231-1.0937,1.6978-1.3547ZM8.6855,20.9191c-1.3947-.0516-5.3871-4.9725-5.5187-6.3293-.1126-1.1673,2.2062-3.2589,2.9399-4.1998.3547-.4537,1.14-2.0147,1.641-2.0473.4168-.0263,1.3157.5378,1.5052.9052.3968.7684-.179.8516-.4274,1.4389-.5137,1.2126-.3632,2.7736-.4127,4.062-.782.1769-1.4136.5273-1.361,1.4294.0253.4453.9062,3.3241,1.141,3.7094.3074.5042.8189.7263,1.3894.7684l-.8968.2632h0ZM9.3718,20.2338c-.4716.0221-.7389-.319-.9337-.6968-.2158-.4189-1.0146-3.0568-1.0431-3.4894-.0347-.52.5684-.8505,1.0294-.8652,0,1.7273.481,3.4041.9473,5.0514h0ZM8.8455,15.1814h5.1051c.3379.0674.7642.5432.7852.9.0264.4274-.3221,2.5242-.4452,3.0189-.0569.2274-.1937.6463-.3453.8126-.5737.6305-3.1567.1979-4.0346.3084-.5968-1.6241-.8789-3.3209-1.0652-5.0399ZM16,24.7495c-2.481-.18-4.9062-1.5852-5.7861-4.0946.9337-.0937,2.0989.1274,2.9999,0,1.6063-.2263,1.34-1.7242,1.7368-2.8957.3389-.1053.6926-.1579,1.0494-.1705.3568.0126.7104.0652,1.0494.1705.3968,1.1715.1305,2.6694,1.7368,2.8957.901.1274,2.0662-.0937,2.9999,0-.8799,2.5094-3.3051,3.9146-5.7861,4.0946ZM18.0546,19.9128c-.1516-.1663-.2884-.5853-.3452-.8126-.1232-.4947-.4716-2.5915-.4453-3.0189.0211-.3568.4473-.8326.7852-.9h5.1051c-.1863,1.7189-.4684,3.4157-1.0652,5.0399-.8779-.1105-3.4609.3221-4.0346-.3084ZM23.5755,15.1825c.4611.0147,1.0641.3452,1.0294.8652-.0284.4326-.8273,3.0704-1.0431,3.4894-.1948.3779-.4621.7189-.9337.6968.4663-1.6473.9473-3.3241.9473-5.0514h.0001ZM23.3144,20.9191l-.8968-.2632c.5705-.0421,1.082-.2642,1.3894-.7684.2347-.3853,1.1157-3.2641,1.141-3.7094.0527-.9021-.5789-1.2526-1.361-1.4294-.0495-1.2883.101-2.8494-.4127-4.062-.2484-.5873-.8242-.6705-.4273-1.4389.1895-.3674,1.0884-.9315,1.5052-.9052.501.0326,1.2863,1.5936,1.641,2.0473.7336.941,3.0526,3.0325,2.9399,4.1998-.1315,1.3568-4.124,6.2777-5.5187,6.3293h0ZM20.723,13.4309c-.1389-.3547-.6295-.9842-1.0126-1.0705-.5095-.1147-1.1579.3179-.9252.8189.2421.5231,1.8536.781,1.9378.2516ZM20.2061,13.2857c-.4252.0189-1.1115.0652-1.0515-.5242.4747-.2242.8031.16,1.0515.5242ZM16,22.0274c-.6074,1.041-1.6042.2295-2.3115-.4252.3514,1.0421,1.1141,1.8438,1.985,2.1157.2104.0657.4424.0657.6529,0,.871-.2719,1.6337-1.0736,1.985-2.1157-.7073.6547-1.7042,1.4662-2.3115.4252h.0001ZM16.4631,23.3104c-.2929.1281-.6333.1281-.9262,0-.213-.0932-.4126-.2253-.5853-.3925.3663-.0379.7895-.0547,1.0484-.2895.2589.2347.682.2516,1.0483.2895-.1727.1671-.3723.2993-.5853.3925h.0001ZM19.9274,16.7916c-1.2811-.0672-1.3152,2.7355-.0814,2.8101,1.3266.0803,1.5042-2.7354.0814-2.8101Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoRedHatAiInstructlabOnIbmCloud.propTypes = iconPropTypes;
}
const LogoRedHatAnsible = /*#__PURE__*/React.forwardRef(function LogoRedHatAnsible({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoRedHatAnsible.propTypes = iconPropTypes;
}
const LogoSketch = /*#__PURE__*/React.forwardRef(function LogoSketch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0 l-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0 c0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1 c-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0 l0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9 c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2 c0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6 c-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoSketch.propTypes = iconPropTypes;
}
const LogoSkype = /*#__PURE__*/React.forwardRef(function LogoSkype({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoSkype.propTypes = iconPropTypes;
}
const LogoSlack = /*#__PURE__*/React.forwardRef(function LogoSlack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0423,19.1661A2.5212,2.5212,0,1,1,6.5212,16.645H9.0423Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3127,19.1661a2.5212,2.5212,0,0,1,5.0423,0v6.3127a2.5212,2.5212,0,1,1-5.0423,0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8339,9.0423A2.5212,2.5212,0,1,1,15.355,6.5212V9.0423Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8339,10.3127a2.5212,2.5212,0,0,1,0,5.0423H6.5212a2.5212,2.5212,0,1,1,0-5.0423Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9577,12.8339a2.5212,2.5212,0,1,1,2.5211,2.5211H22.9577Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6873,12.8339a2.5212,2.5212,0,0,1-5.0423,0V6.5212a2.5212,2.5212,0,1,1,5.0423,0Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1661,22.9577a2.5212,2.5212,0,1,1-2.5211,2.5211V22.9577Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1661,21.6873a2.5212,2.5212,0,0,1,0-5.0423h6.3127a2.5212,2.5212,0,1,1,0,5.0423Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoSlack.propTypes = iconPropTypes;
}
const LogoSnapchat = /*#__PURE__*/React.forwardRef(function LogoSnapchat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoSnapchat.propTypes = iconPropTypes;
}
const LogoSvelte = /*#__PURE__*/React.forwardRef(function LogoSvelte({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8 c-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8 C27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2 c0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1 c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6 c-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20 l0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2 c0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6 c-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1 C24.2,8.5,24.5,9.8,24.3,11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoSvelte.propTypes = iconPropTypes;
}
const LogoTumblr = /*#__PURE__*/React.forwardRef(function LogoTumblr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoTumblr.propTypes = iconPropTypes;
}
const LogoTwitter = /*#__PURE__*/React.forwardRef(function LogoTwitter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoTwitter.propTypes = iconPropTypes;
}
const LogoVmware = /*#__PURE__*/React.forwardRef(function LogoVmware({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5 c0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9 V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8 c0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7 l-2.5,5.9L3.4,11"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoVmware.propTypes = iconPropTypes;
}
const LogoVmwareAlt = /*#__PURE__*/React.forwardRef(function LogoVmwareAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4131,19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415,0-.5114,.4112-1.0128,1.073-1.0128,.5515,0,.9226,.351,1.083,.8624l1.2034,3.9812,1.2335-3.9711c.1604-.5315,.5716-.8925,1.1432-.8925h.1304c.5716,0,.9828,.371,1.1432,.8925l1.2435,3.9812,1.2335-4.0113c.1504-.4713,.4814-.8524,1.073-.8524,.6117,0,1.0429,.4713,1.0429,1.0229,0,.1504-.0401,.351-.0702,.4513l-2.0056,5.6258c-.2306,.6919-.6919,.9928-1.2335,.9928h-.0702c-.5415,0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635,3.9511c-.2006,.6418-.6619,.9527-1.2034,.9527h-.0702c-.5315,0-.9928-.3109-1.2234-.9928Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0939,12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828,.2568-.7902,.8989-.5334,1.452l2.4299,5.2846c.3852,.8297,.7902,1.2644,1.5409,1.2644,.81,0,1.1656-.4741,1.5409-1.2644,0,0,2.1237-4.6228,2.1435-4.6722,.0198-.0494,.0889-.1976,.3062-.1976,.1877,0,.3358,.1482,.3358,.3457v4.524c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299,1.0372-2.4299,1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248,0-2.3015,1.0372-2.3015,1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866,0-1.9459,.4741-2.4694,1.6792l-1.5508,3.6647-1.9756-4.7018"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoVmwareAlt.propTypes = iconPropTypes;
}
const LogoVue = /*#__PURE__*/React.forwardRef(function LogoVue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoVue.propTypes = iconPropTypes;
}
const LogoWechat = /*#__PURE__*/React.forwardRef(function LogoWechat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoWechat.propTypes = iconPropTypes;
}
const LogoX = /*#__PURE__*/React.forwardRef(function LogoX({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2342,14.1624l8.7424-10.1624h-2.0717l-7.591,8.8238-6.0629-8.8238h-6.9929l9.1684,13.3432-9.1684,10.6568h2.0718l8.0163-9.3183,6.4029,9.3183h6.9929l-9.5083-13.8376h.0005Zm-2.8376,3.2984l-.9289-1.3287L7.0763,5.5596h3.1822l5.9649,8.5323.9289,1.3287,7.7536,11.0907h-3.1822l-6.3272-9.05v-.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoX.propTypes = iconPropTypes;
}
const LogoXing = /*#__PURE__*/React.forwardRef(function LogoXing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoXing.propTypes = iconPropTypes;
}
const LogoYelp = /*#__PURE__*/React.forwardRef(function LogoYelp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5089,15.1845l5.0598,2.4675c.9733,.4747,.8229,1.9059-.2278,2.1679l-5.4618,1.3619c-.6813,.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655,.4564-4.3296,.2227-.6625,.9797-.9764,1.6079-.67Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5348,25.6004l3.7659-4.1831c.7245-.8048,2.0589-.2657,2.0211,.8165l-.1964,5.6273c-.0245,.7012-.6613,1.2203-1.3532,1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.464,20.0339l5.3529,1.7396c.6663,.2165,.9912,.9705,.6894,1.6027-.6279,1.3155-1.5387,2.4909-2.6766,3.4301-.5412,.4466-1.3521,.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184,.3123-2.0524,1.3421-1.7177Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.9076,16.619l-5.411,1.5515c-1.0409,.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795,1.2034-.6861,1.7275-.2237,1.0791,.9521,1.9628,2.1433,2.56,3.5214,.2792,.6443-.0685,1.3877-.7434,1.5813Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.2638,3.4886c-.9739,.2609-1.903,.6058-2.7815,1.0247-.6096,.2907-.8399,1.0415-.5022,1.6264l5.2887,9.1604c.5934,1.0277,2.1643,.6067,2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703,.0765-1.9474,.2424-2.9212,.5033Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoYelp.propTypes = iconPropTypes;
}
const LogoYoutube = /*#__PURE__*/React.forwardRef(function LogoYoutube({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LogoYoutube.propTypes = iconPropTypes;
}
const Logout = /*#__PURE__*/React.forwardRef(function Logout({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Logout.propTypes = iconPropTypes;
}
const Loop = /*#__PURE__*/React.forwardRef(function Loop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13,6A9,9,0,0,0,5.52,20l1.66-1.11A7,7,0,1,1,13,22H2v2H13A9,9,0,0,0,13,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Loop.propTypes = iconPropTypes;
}
const LoopAlt = /*#__PURE__*/React.forwardRef(function LoopAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M15.271,10v9.9883h4.729v2.0117h-6.999v-12h2.27ZM23,25h3.7517c-1.2576,1.8159-3.3484,3-5.7517,3h-10c-3.8999,0-7-3.1001-7-7v-8h-2v8c0,5,4,9,9,9h9.9998c2.8477,0,5.3555-1.311,7.0002-3.3516v3.3516h2v-7h-7v2ZM21,2h-9.9998c-2.8477,0-5.3555,1.311-7.0002,3.3516v-3.3516h-2v7h7v-2h-3.7517c1.2576-1.8159,3.3484-3,5.7517-3h10c3.8999,0,7,3.1001,7,7v8h2v-8c0-5-4-9-9-9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LoopAlt.propTypes = iconPropTypes;
}
const LowSeverity = /*#__PURE__*/React.forwardRef(function LowSeverity({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
      d: "M4 4H12V12H4z"
    })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
      d: "M12,4v8H4V4h8m1-1H3V13H13V3Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H12V12H4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4v8H4V4h8m1-1H3V13H13V3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  LowSeverity.propTypes = iconPropTypes;
}
const Mac = /*#__PURE__*/React.forwardRef(function Mac({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,23h-6c-1.103,0-2-.8975-2-2v-10c0-1.103.897-2,2-2h6v2h-6v10h6v2Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m18,9h-4c-1.103,0-2,.897-2,2v12h2v-5h4v5h2v-12c0-1.103-.897-2-2-2Zm-4,7v-5h4v5h-4Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 9L6.4849 14 6 15.977 5.535 14 4 9 2 9 2 23 4 23 4 15 3.8415 13.0039 4.4212 15 6 19.6263 7.5788 15 8.1588 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mac.propTypes = iconPropTypes;
}
const MacCommand = /*#__PURE__*/React.forwardRef(function MacCommand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MacCommand.propTypes = iconPropTypes;
}
const MacOption = /*#__PURE__*/React.forwardRef(function MacOption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H28V7H18z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MacOption.propTypes = iconPropTypes;
}
const MacShift = /*#__PURE__*/React.forwardRef(function MacShift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MacShift.propTypes = iconPropTypes;
}
const MachineLearning = /*#__PURE__*/React.forwardRef(function MachineLearning({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["MachineLearning"]) {
      didWarnAboutDeprecation["MachineLearning"] = true;
      console.warn("Icon should not be used. Teams should use machine-learning-model instead. As a result, the MachineLearning component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,25Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,14Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,14Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MachineLearning.propTypes = iconPropTypes;
}
const MachineLearningModel = /*#__PURE__*/React.forwardRef(function MachineLearningModel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8384-2.8157,2h-5.7703l7.3008-7.3008c.3911.1875.8235.3008,1.2852.3008,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.4619.1135.894.3005,1.2852l-8.3005,8.3008v-6.5859c0-1.1025.897-2,2-2h2v-2h-2c-1.2002,0-2.2661.5425-3,1.3823-.7339-.8398-1.7998-1.3823-3-1.3823h-1c-4.9624,0-9,4.0371-9,9v6c0,4.9629,4.0376,9,9,9h1c1.2002,0,2.2661-.5425,3-1.3823.7339.8398,1.7998,1.3823,3,1.3823h2v-2h-2c-1.103,0-2-.8975-2-2v-6.5859l8.3005,8.3008c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3c-.4617,0-.894.1133-1.2852.3008l-7.3008-7.3008h5.7703c.4141,1.1616,1.5137,2,2.8157,2Zm0-4c.5513,0,1,.4482,1,1s-.4487,1-1,1-1-.4482-1-1,.4487-1,1-1Zm0-11c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm-13,8h-2v2h2v4h-2c-1.6543,0-3,1.3457-3,3v2h2v-2c0-.5518.4487-1,1-1h2v4c0,1.1025-.897,2-2,2h-1c-3.5195,0-6.4324-2.6133-6.9202-6h1.9202v-2h-2v-4h3c1.6543,0,3-1.3457,3-3v-2h-2v2c0,.5518-.4487,1-1,1h-2.9202c.4878-3.3867,3.4006-6,6.9202-6h1c1.103,0,2,.8975,2,2v4Zm14,15c0,.5513-.4485,1-1,1s-1-.4487-1-1,.4485-1,1-1,1,.4487,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MachineLearningModel.propTypes = iconPropTypes;
}
const MagicWand = /*#__PURE__*/React.forwardRef(function MagicWand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 14.586H5.414V17.414H2.586z",
    transform: "rotate(-45 4 16)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14.586 2.586H17.414V5.414H14.586z",
    transform: "rotate(-45 16 4)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 2.586H5.414V5.414H2.586z",
    transform: "rotate(-45 4 4)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MagicWand.propTypes = iconPropTypes;
}
const MagicWandFilled = /*#__PURE__*/React.forwardRef(function MagicWandFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 14.586H5.414V17.414H2.586z",
    transform: "rotate(-45 4 16)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14.586 2.586H17.414V5.414H14.586z",
    transform: "rotate(-45 16 4)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 2.586H5.414V5.414H2.586z",
    transform: "rotate(-45 4 4)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MagicWandFilled.propTypes = iconPropTypes;
}
const WatsonHealthMagnify = /*#__PURE__*/React.forwardRef(function WatsonHealthMagnify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthMagnify.propTypes = iconPropTypes;
}
const MailAll = /*#__PURE__*/React.forwardRef(function MailAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MailAll.propTypes = iconPropTypes;
}
const MailReply = /*#__PURE__*/React.forwardRef(function MailReply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MailReply.propTypes = iconPropTypes;
}
const WatsonHealthMammogram = /*#__PURE__*/React.forwardRef(function WatsonHealthMammogram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32L32 32 32 25 30 25 30 30 25 30 25 32z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25,27H22V17h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,27Zm-1-2h1a1.0006,1.0006,0,0,0,1-1V20a1.0006,1.0006,0,0,0-1-1H24Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H14V23a2.002,2.002,0,0,1,2-2h2V19H14V17h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H16v2h4Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15H22V5h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,15Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V8a1.0009,1.0009,0,0,0-1-1H24Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M18,5H14V7h4V9H15v2h3v2H14v2h4a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,18,5Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M10,27H8V23.9541C3.2847,23.5117,2,19.9443,2,18c0-3.0146,2.082-4.5015,3.9189-5.814C7.5723,11.0054,9,9.9854,9,8V5h2V8c0,3.0146-2.082,4.5015-3.9189,5.814C5.4277,14.9946,4,16.0146,4,18c.0054.4033.1914,4,5,4a1,1,0,0,1,1,1Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthMammogram.propTypes = iconPropTypes;
}
const ManageProtection = /*#__PURE__*/React.forwardRef(function ManageProtection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ManageProtection.propTypes = iconPropTypes;
}
const ManagedSolutions = /*#__PURE__*/React.forwardRef(function ManagedSolutions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ManagedSolutions.propTypes = iconPropTypes;
}
const Map = /*#__PURE__*/React.forwardRef(function Map({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Map.propTypes = iconPropTypes;
}
const MapCenter = /*#__PURE__*/React.forwardRef(function MapCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18H25V22H23z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H30V25H26z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H22V25H18z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.0011,1.0011,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6015-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0268,7.5678L4.6719,4.6715l17.5244,6.3726Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MapCenter.propTypes = iconPropTypes;
}
const MapIdentify = /*#__PURE__*/React.forwardRef(function MapIdentify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V14H15z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V24H15z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H24V17H18z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M4,10H2V4A2.0021,2.0021,0,0,1,4,2h6V4H4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2.0021,2.0021,0,0,1-2-2V22H4v6h6Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22V28h6V22h2v6A2.0021,2.0021,0,0,1,28,30Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10H28V4H22V2h6a2.0021,2.0021,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MapIdentify.propTypes = iconPropTypes;
}
const MapBoundary = /*#__PURE__*/React.forwardRef(function MapBoundary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V14H12z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18L14 16 12 16 12 20 16 20 16 18 14 18z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H28V16H16z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MapBoundary.propTypes = iconPropTypes;
}
const MapBoundaryVegetation = /*#__PURE__*/React.forwardRef(function MapBoundaryVegetation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16H18V14h5V10a2,2,0,0,1,2-2h1.5a1.5,1.5,0,0,0,.2837-2.9734l-.7109-.1355L25.9982,4.32a2.6322,2.6322,0,0,0-1.68-2.1823,2.5051,2.5051,0,0,0-3.0836,1.3042l-.3032.6472-.71-.0771a2.0185,2.0185,0,0,0-2.17,2.4343A2.0976,2.0976,0,0,0,20.1261,8H21v2h-.7817A4.1491,4.1491,0,0,1,16.012,6.3136a4.0047,4.0047,0,0,1,3.7414-4.306A4.5006,4.5006,0,0,1,27.8267,3.26a3.5051,3.5051,0,0,1,2.1422,3.7094A3.6283,3.6283,0,0,1,26.3172,10H25v4h3Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18L14 16 12 16 12 20 16 20 16 18 14 18z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V14H12z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MapBoundaryVegetation.propTypes = iconPropTypes;
}
const MarineWarning = /*#__PURE__*/React.forwardRef(function MarineWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MarineWarning.propTypes = iconPropTypes;
}
const MathCurve = /*#__PURE__*/React.forwardRef(function MathCurve({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MathCurve.propTypes = iconPropTypes;
}
const QMatrix = /*#__PURE__*/React.forwardRef(function QMatrix({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,20A3.5,3.5,0,1,1,13,23.5,3.5,3.5,0,0,1,16.5,20m0-2A5.5,5.5,0,1,0,22,23.5,5.5,5.5,0,0,0,16.5,18Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QMatrix.propTypes = iconPropTypes;
}
const Maximize = /*#__PURE__*/React.forwardRef(function Maximize({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
      d: "M6 15L6 14 2.7 14 7 9.7 6.3 9 2 13.3 2 10 1 10 1 15z"
    })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
      d: "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Maximize.propTypes = iconPropTypes;
}
const MediaLibrary = /*#__PURE__*/React.forwardRef(function MediaLibrary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15L13 23 13 23 20 19 13 15z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28ZM6,12V26H26V12Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H24V4H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MediaLibrary.propTypes = iconPropTypes;
}
const MediaLibraryFilled = /*#__PURE__*/React.forwardRef(function MediaLibraryFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13 15L13 23 13 23 20 19 13 15z",
    "data-icon-path": "inner-path"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6a2.0023,2.0023,0,0,0-2,2V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,26,10ZM13,23h0V15l7,4Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H24V4H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MediaLibraryFilled.propTypes = iconPropTypes;
}
const MediaCast = /*#__PURE__*/React.forwardRef(function MediaCast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M2,26H5a3,3,0,0,0-3-3Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M9,26H7a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,9,26Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MediaCast.propTypes = iconPropTypes;
}
const Medication = /*#__PURE__*/React.forwardRef(function Medication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Medication.propTypes = iconPropTypes;
}
const MedicationAlert = /*#__PURE__*/React.forwardRef(function MedicationAlert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19H24V24H22z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "26",
    r: "1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MedicationAlert.propTypes = iconPropTypes;
}
const MedicationReminder = /*#__PURE__*/React.forwardRef(function MedicationReminder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MedicationReminder.propTypes = iconPropTypes;
}
const Menu = /*#__PURE__*/React.forwardRef(function Menu({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
      d: "M2 12H14V13H2z"
    })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
      d: "M2 9H14V10H2z"
    })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
      d: "M2 6H14V7H2z"
    })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
      d: "M2 3H14V4H2z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
      d: "M2 14.8H18V16H2z"
    })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
      d: "M2 11.2H18V12.399999999999999H2z"
    })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
      d: "M2 7.6H18V8.799999999999999H2z"
    })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
      d: "M2 4H18V5.2H2z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
      d: "M3 18H21V19.5H3z"
    })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
      d: "M3 13.5H21V15H3z"
    })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
      d: "M3 9H21V10.5H3z"
    })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
      d: "M3 4.5H21V6H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H28V8H4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H28V26H4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H28V14H4z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H28V20H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Menu.propTypes = iconPropTypes;
}
const Merge = /*#__PURE__*/React.forwardRef(function Merge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,13c-1.8584,0-3.4106,1.2798-3.8579,3h-6.1421c-2.7571,0-5-2.2432-5-5v-1.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v12.2842c-1.7202.4468-3,1.9995-3,3.8579,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8584-1.2798-3.4111-3-3.8579v-6.2524c1.2717,1.3003,3.042,2.1104,5,2.1104h6.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-14,13c0,1.1025-.897,2-2,2s-2-.8975-2-2,.897-2,2-2,2,.8975,2,2ZM6,6c0-1.103.897-2,2-2s2,.897,2,2-.897,2-2,2-2-.897-2-2Zm18,13c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Merge.propTypes = iconPropTypes;
}
const MergeNode = /*#__PURE__*/React.forwardRef(function MergeNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,20h-4l-8-8-8,8h-4c-1.1028,0-2,.8975-2,2v8h2v-8h4l8,8,8-8h4v8h2v-8c0-1.1025-.8972-2-2-2Zm-12,7.1714l-6.1714-6.1714,6.1714-6.1716,6.1714,6.1716-6.1714,6.1714Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11 7L16 12 21 7 19.5859 5.5859 17 8.1719 17 2 15 2 15 8.1719 12.4141 5.5859 11 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MergeNode.propTypes = iconPropTypes;
}
const MessageQueue = /*#__PURE__*/React.forwardRef(function MessageQueue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H25V23H7z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H25V18H7z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H25V13H7z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H25V8H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MessageQueue.propTypes = iconPropTypes;
}
const Meter = /*#__PURE__*/React.forwardRef(function Meter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a9.9283,9.9283,0,0,0-1.1392-4.6182l-1.4961,1.4961A7.9483,7.9483,0,0,1,24,16Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,10,22,8.5859l-4.7147,4.7147A2.9659,2.9659,0,0,0,16,13a3,3,0,1,0,3,3,2.9659,2.9659,0,0,0-.3006-1.2853ZM16,17a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,16,17Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a7.9515,7.9515,0,0,1,3.1223.6353l1.4961-1.4961A9.9864,9.9864,0,0,0,6,16H8A8.0092,8.0092,0,0,1,16,8Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Meter.propTypes = iconPropTypes;
}
const MeterAlt = /*#__PURE__*/React.forwardRef(function MeterAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20a13.8535,13.8535,0,0,0-2.2291-7.5288l-1.4452,1.4453A11.8917,11.8917,0,0,1,28,20Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9.414,26.5859,8,18.019,16.5669A3.9521,3.9521,0,0,0,16,16a4,4,0,1,0,4,4,3.9533,3.9533,0,0,0-.5669-2.0191ZM16,22a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,22Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a11.9086,11.9086,0,0,1,6.0833,1.6743l1.4536-1.4536A13.9773,13.9773,0,0,0,2,20H4A12.0137,12.0137,0,0,1,16,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MeterAlt.propTypes = iconPropTypes;
}
const Microphone = /*#__PURE__*/React.forwardRef(function Microphone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Microphone.propTypes = iconPropTypes;
}
const MicrophoneFilled = /*#__PURE__*/React.forwardRef(function MicrophoneFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MicrophoneFilled.propTypes = iconPropTypes;
}
const MicrophoneOff = /*#__PURE__*/React.forwardRef(function MicrophoneOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18,18.57A7.41,7.41,0,0,1,9,17V14H7v3a8.84,8.84,0,0,0,.58,3.18Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M13,15V7a3,3,0,0,1,6,0V8.75l2-2A5,5,0,0,0,11,7v8Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Zm-4,0a3,3,0,0,1-4.9,2.31L19,14.42Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MicrophoneOff.propTypes = iconPropTypes;
}
const MicrophoneOffFilled = /*#__PURE__*/React.forwardRef(function MicrophoneOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17.32c0-.11,0-.21,0-.32V14H7v3a9,9,0,0,0,.25,2.09Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M20.76,5.58A5,5,0,0,0,11,7v8.34Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MicrophoneOffFilled.propTypes = iconPropTypes;
}
const Microscope = /*#__PURE__*/React.forwardRef(function Microscope({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Microscope.propTypes = iconPropTypes;
}
const Microservices_1 = /*#__PURE__*/React.forwardRef(function Microservices_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11 21-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM24.6 11.6 22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5-1.4-1.4zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  Microservices_1.propTypes = iconPropTypes;
}
const Microservices_2 = /*#__PURE__*/React.forwardRef(function Microservices_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-6h-6v-6H2v20h20v-8h-6zm-2-4v4h-4v-4h4zM4 12h4v4H4v-4zm4 6v4H4v-4h4zM4 28v-4h4v4H4zm10 0h-4v-4h4v4zm6 0h-4v-4h4v4zM29.6 13.6 27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5-1.4-1.4zM24 4h4v4h-4V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  Microservices_2.propTypes = iconPropTypes;
}
const Migrate = /*#__PURE__*/React.forwardRef(function Migrate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V8a2,2,0,0,0,2,2h9v6.17l-2.59-2.58L11,15l5,5,5-5-1.41-1.41L17,16.17V10h9a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2ZM6,4h4V8H6ZM26,8H12V4H26Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V24A2,2,0,0,0,26,22ZM6,24H20v4H6Zm20,4H22V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Migrate.propTypes = iconPropTypes;
}
const MigrateAlt = /*#__PURE__*/React.forwardRef(function MigrateAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MigrateAlt.propTypes = iconPropTypes;
}
const Milestone = /*#__PURE__*/React.forwardRef(function Milestone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Milestone.propTypes = iconPropTypes;
}
const MilitaryCamp = /*#__PURE__*/React.forwardRef(function MilitaryCamp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MilitaryCamp.propTypes = iconPropTypes;
}
const Minimize = /*#__PURE__*/React.forwardRef(function Minimize({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
      d: "M2 9L2 10 5.3 10 1 14.3 1.7 15 6 10.7 6 14 7 14 7 9z"
    })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
      d: "M14 7L14 6 10.7 6 15 1.7 14.3 1 10 5.3 10 2 9 2 9 7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Minimize.propTypes = iconPropTypes;
}
const Misuse = /*#__PURE__*/React.forwardRef(function Misuse({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
    })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8 l2.7,2.7L10.7,11.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1 L11,10l3.5,3.5L13.5,14.5z"
    })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3 l4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z"
    })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3 L13.3,12l4.2,4.2L16.2,17.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16 l5.4,5.4L21.4,23z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Misuse.propTypes = iconPropTypes;
}
const MisuseOutline = /*#__PURE__*/React.forwardRef(function MisuseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7 11.5L8 8.8 5.3 11.5 4.5 10.7 7.2 8 4.5 5.3 5.3 4.5 8 7.2 10.7 4.5 11.5 5.3 8.8 8 11.5 10.7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MisuseOutline.propTypes = iconPropTypes;
}
const MixedRainHail = /*#__PURE__*/React.forwardRef(function MixedRainHail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MixedRainHail.propTypes = iconPropTypes;
}
const MlModelReference = /*#__PURE__*/React.forwardRef(function MlModelReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 19L4 21 8.5859 21 2 27.5859 3.4141 29 10 22.4141 10 27 12 27 12 19 4 19z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8384-2.8157,2h-5.7703l7.3008-7.3008c.3911.1875.8235.3008,1.2852.3008,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.4619.1135.894.3005,1.2852l-8.3005,8.3008v-6.5859c0-1.1025.897-2,2-2h2v-2h-2c-1.2002,0-2.2661.5425-3,1.3823-.7339-.8398-1.7998-1.3823-3-1.3823h-1c-4.9624,0-9,4.0371-9,9v4h2v-3h3c1.6543,0,3-1.3457,3-3v-2h-2v2c0,.5518-.4487,1-1,1h-2.9202c.4878-3.3867,3.4006-6,6.9202-6h1c1.103,0,2,.8975,2,2v4h-2v2h2v10c0,2.2056,1.7944,4,4,4h2v-2h-2c-1.1028,0-2-.8975-2-2v-6.5859l8.3005,8.3008c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3c-.4617,0-.894.1133-1.2852.3008l-7.3008-7.3008h5.7703c.4141,1.1616,1.5137,2,2.8157,2Zm0-4c.5513,0,1,.4482,1,1s-.4487,1-1,1-1-.4482-1-1,.4487-1,1-1Zm0-11c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm0,22c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MlModelReference.propTypes = iconPropTypes;
}
const Mobile = /*#__PURE__*/React.forwardRef(function Mobile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mobile.propTypes = iconPropTypes;
}
const MobileAdd = /*#__PURE__*/React.forwardRef(function MobileAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileAdd.propTypes = iconPropTypes;
}
const MobileAudio = /*#__PURE__*/React.forwardRef(function MobileAudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H30V15H28z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7H26V20H24z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H22V16H20z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H18V18H16z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V15H12z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "24.5",
    r: "1.5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileAudio.propTypes = iconPropTypes;
}
const MobileCheck = /*#__PURE__*/React.forwardRef(function MobileCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileCheck.propTypes = iconPropTypes;
}
const MobileCrash = /*#__PURE__*/React.forwardRef(function MobileCrash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L26 16 24.5859 17.4141 27.1714 20 24.1714 23 27.1714 26 24.5859 28.5859 26 30 30 26 27 23 30 20z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20L19 16 17.5859 17.4141 20.1714 20 17.1714 23 20.1714 26 17.5859 28.5859 19 30 23 26 20 23 23 20z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m15,28h-6V8h14v6h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileCrash.propTypes = iconPropTypes;
}
const MobileDownload = /*#__PURE__*/React.forwardRef(function MobileDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileDownload.propTypes = iconPropTypes;
}
const MobileEvent = /*#__PURE__*/React.forwardRef(function MobileEvent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3803,28h-6.7625l3.3822-6.7642,3.3803,6.7642Zm-3.3803-10c-.3915,0-.7305.2251-.8947.5527l-5,10c-.0674.1348-.1053.2866-.1053.4473,0,.5522.4477,1,1,1h10c.5523,0,1-.4478,1-1,0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m15,28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileEvent.propTypes = iconPropTypes;
}
const MobileLandscape = /*#__PURE__*/React.forwardRef(function MobileLandscape({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileLandscape.propTypes = iconPropTypes;
}
const MobileRequest = /*#__PURE__*/React.forwardRef(function MobileRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileRequest.propTypes = iconPropTypes;
}
const MobileSession = /*#__PURE__*/React.forwardRef(function MobileSession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileSession.propTypes = iconPropTypes;
}
const MobileView = /*#__PURE__*/React.forwardRef(function MobileView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileView.propTypes = iconPropTypes;
}
const MobileViewOrientation = /*#__PURE__*/React.forwardRef(function MobileViewOrientation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobileViewOrientation.propTypes = iconPropTypes;
}
const MobilityServices = /*#__PURE__*/React.forwardRef(function MobilityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H24a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2V6H24V4Zm-4,8V8h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MobilityServices.propTypes = iconPropTypes;
}
const Model = /*#__PURE__*/React.forwardRef(function Model({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,24.1841V7.8159c1.1616-.4146,2-1.5142,2-2.8159,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,.3916.0806.7632.2173,1.106l-9.2173,8.0654L6.7827,6.1064c.137-.3433.2173-.7148.2173-1.1064,0-1.6543-1.3457-3-3-3S1,3.3457,1,5c0,1.3018.8384,2.4014,2,2.8154v16.3691c-1.1616.4141-2,1.5137-2,2.8154,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.6665-.2258-1.2769-.5952-1.7754l5.3335-4.667,2.3645,4.1377c-.6677.5508-1.1028,1.3735-1.1028,2.3047,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.9312-.4353-1.7539-1.1028-2.3047l2.3645-4.1377,5.3335,4.667c-.3694.4985-.5952,1.1089-.5952,1.7754,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-1.3018-.8384-2.4014-2-2.8159Zm-1-20.1841c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm-3.822,5.6729l-4.4397,7.7695-2.2197-1.9424,6.6594-5.8271Zm-9.6965,5.8271l-2.22,1.9424-4.4397-7.7695,6.6597,5.8271ZM4,4c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm0,24c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm1-4.2036v-15.0308l5.7261,10.0205-5.7261,5.0103Zm11,4.2036c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm0-4.0151l-2.7261-4.771,2.7261-2.3853,2.7261,2.3853-2.7261,4.771Zm11-15.2197v15.0312l-5.7261-5.0103,5.7261-10.021Zm1,19.2349c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Model.propTypes = iconPropTypes;
}
const ModelAlt = /*#__PURE__*/React.forwardRef(function ModelAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelAlt.propTypes = iconPropTypes;
}
const ModelFoundation = /*#__PURE__*/React.forwardRef(function ModelFoundation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2h-5.7703l7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8385,2.8157-2h5.7703l-7.3005,7.3006c-.3911-.1871-.8237-.3006-1.2854-.3006-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8385,2.8157-2h16.3687c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-.4617,0-.8943.1135-1.2854.3006l-7.3005-7.3006h5.7703c.4141,1.1615,1.5137,2,2.8157,2Zm0-4c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM7.8157,6h16.3687c.0349.0976.072.1927.1162.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0815-.1877.1162-.2853Zm19.1843-2c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1Zm-23,1c0-.5513.4482-1,1-1s1,.4487,1,1-.4482,1-1,1-1-.4487-1-1Zm1,12c-.5518,0-1-.4487-1-1s.4482-1,1-1,1,.4487,1,1-.4482,1-1,1Zm19.1843,9H7.8157c-.0347-.0976-.072-.1927-.1162-.2853l8.3005-8.3006,8.3005,8.3006c-.0442.0927-.0815.1877-.1162.2853Zm-19.1843,2c-.5518,0-1-.4487-1-1s.4482-1,1-1,1,.4487,1,1-.4482,1-1,1Zm23-1c0,.5513-.4482,1-1,1s-1-.4487-1-1,.4482-1,1-1,1,.4487,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelFoundation.propTypes = iconPropTypes;
}
const ModelReference = /*#__PURE__*/React.forwardRef(function ModelReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20L4 22 8.5859 22 2 28.5859 3.4141 30 10 23.4141 10 28 12 28 12 20 4 20z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2h-5.7703l7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3v1h2v-1c0-.5513.4482-1,1-1s1,.4487,1,1v1h9.5859l8.7146,8.7147c-.0442.0927-.0815.1877-.1162.2853h-10.1843v2h10.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-.4617,0-.8943.1135-1.2854.3006l-7.3005-7.3006h5.7703c.4141,1.1615,1.5137,2,2.8157,2Zm1,8c0,.5513-.4482,1-1,1s-1-.4487-1-1,.4482-1,1-1,1,.4487,1,1Zm-1-12c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM7.8157,6h16.3687c.0349.0976.072.1927.1162.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0815-.1877.1162-.2853Zm19.1843-2c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM4,5c0-.5513.4482-1,1-1s1,.4487,1,1-.4482,1-1,1-1-.4487-1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelReference.propTypes = iconPropTypes;
}
const ModelTuned = /*#__PURE__*/React.forwardRef(function ModelTuned({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,30v-2.2773c.5952-.3464,1-.9841,1-1.7227s-.4048-1.3762-1-1.7227v-4.2773h-2v4.2773c-.5952.3464-1,.9844-1,1.7227s.4048,1.3762,1,1.7227v2.2773h2Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31,24c0-.7383-.4048-1.376-1-1.7227v-2.2773h-2v2.2773c-.5952.3467-1,.9844-1,1.7227s.4048,1.376,1,1.7227v4.2773h2v-4.2773c.5952-.3467,1-.9844,1-1.7227Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m7.8157,17h5.7703s-7.3005,7.3006-7.3005,7.3006c-.3911-.1871-.8237-.3006-1.2854-.3006-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,1.302,0,2.4016-.8385,2.8157-2h10.1843s0-2,0-2H7.8157c-.0347-.0976-.072-.1927-.1162-.2853l8.7146-8.7147h9.5859s0-1,0-1c0-.5513.4482-1,1-1s1,.4487,1,1v1s2,0,2,0v-1c0-1.6543-1.3457-3-3-3-1.302,0-2.4016.8385-2.8157,2h-5.7703s7.3005-7.3006,7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3,0-1.6543-1.3457-3-3-3-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,1.302,0,2.4016-.8385,2.8157-2Zm-2.8157,9c.5518,0,1,.4487,1,1,0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1Zm1-10c0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1s1,.4487,1,1ZM24.3005,6.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0813-.1877.1162-.2853h16.3687c.0347.0976.072.1927.1162.2853Zm-18.3005-1.2853c0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1s1,.4487,1,1Zm21,1c-.5518,0-1-.4487-1-1,0-.5513.4482-1,1-1s1,.4487,1,1c0,.5513-.4482,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelTuned.propTypes = iconPropTypes;
}
const ModelBuilder = /*#__PURE__*/React.forwardRef(function ModelBuilder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelBuilder.propTypes = iconPropTypes;
}
const ModelBuilderReference = /*#__PURE__*/React.forwardRef(function ModelBuilderReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ModelBuilderReference.propTypes = iconPropTypes;
}
const Money = /*#__PURE__*/React.forwardRef(function Money({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,16Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,10Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Money.propTypes = iconPropTypes;
}
const Monster = /*#__PURE__*/React.forwardRef(function Monster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H23V16H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Monster.propTypes = iconPropTypes;
}
const Monument = /*#__PURE__*/React.forwardRef(function Monument({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Monument.propTypes = iconPropTypes;
}
const Moon = /*#__PURE__*/React.forwardRef(function Moon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Moon.propTypes = iconPropTypes;
}
const Moonrise = /*#__PURE__*/React.forwardRef(function Moonrise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Moonrise.propTypes = iconPropTypes;
}
const Moonset = /*#__PURE__*/React.forwardRef(function Moonset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Moonset.propTypes = iconPropTypes;
}
const MostlyCloudy = /*#__PURE__*/React.forwardRef(function MostlyCloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MostlyCloudy.propTypes = iconPropTypes;
}
const MostlyCloudyNight = /*#__PURE__*/React.forwardRef(function MostlyCloudyNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  MostlyCloudyNight.propTypes = iconPropTypes;
}
const Mountain = /*#__PURE__*/React.forwardRef(function Mountain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mountain.propTypes = iconPropTypes;
}
const Mov = /*#__PURE__*/React.forwardRef(function Mov({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11V21h4V11Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Mov.propTypes = iconPropTypes;
}

export { LogoFacebook, LogoFigma, LogoFlickr, LogoGit, LogoGithub, LogoGitlab, LogoGlassdoor, LogoInstagram, LogoInvision, LogoJupyter, LogoKeybase, LogoKubernetes, LogoLinkedin, LogoLivestream, LogoMastodon, LogoMedium, LogoNpm, LogoOpenshift, LogoPinterest, LogoPython, LogoQuora, LogoRScript, LogoReact, LogoRedHatAiInstructlabOnIbmCloud, LogoRedHatAnsible, LogoSketch, LogoSkype, LogoSlack, LogoSnapchat, LogoSvelte, LogoTumblr, LogoTwitter, LogoVmware, LogoVmwareAlt, LogoVue, LogoWechat, LogoX, LogoXing, LogoYelp, LogoYoutube, Logout, Loop, LoopAlt, LowSeverity, Mac, MacCommand, MacOption, MacShift, MachineLearning, MachineLearningModel, MagicWand, MagicWandFilled, MailAll, MailReply, ManageProtection, ManagedSolutions, Map, MapBoundary, MapBoundaryVegetation, MapCenter, MapIdentify, MarineWarning, MathCurve, Maximize, MediaCast, MediaLibrary, MediaLibraryFilled, Medication, MedicationAlert, MedicationReminder, Menu, Merge, MergeNode, MessageQueue, Meter, MeterAlt, Microphone, MicrophoneFilled, MicrophoneOff, MicrophoneOffFilled, Microscope, Microservices_1, Microservices_2, Migrate, MigrateAlt, Milestone, MilitaryCamp, Minimize, Misuse, MisuseOutline, MixedRainHail, MlModelReference, Mobile, MobileAdd, MobileAudio, MobileCheck, MobileCrash, MobileDownload, MobileEvent, MobileLandscape, MobileRequest, MobileSession, MobileView, MobileViewOrientation, MobilityServices, Model, ModelAlt, ModelBuilder, ModelBuilderReference, ModelFoundation, ModelReference, ModelTuned, Money, Monster, Monument, Moon, Moonrise, Moonset, MostlyCloudy, MostlyCloudyNight, Mountain, Mov, QMatrix, WatsonHealthMagnify, WatsonHealthMammogram };
